import M from "../../../@babel/runtime/helpers/esm/objectSpread22.mjs";
import l from "../../../@babel/runtime/helpers/esm/slicedToArray2.mjs";
import $o from "../../../@babel/runtime/helpers/esm/objectWithoutProperties2.mjs";
import Te from "../../portal/es/Portal.mjs";
import j from "../../../classnames/index2.mjs";
import en from "../../../rc-resize-observer/es/index.mjs";
import { isDOM as Se } from "../../../rc-util/es/Dom/findDOMNode.mjs";
import { getShadowRoot as we } from "../../../rc-util/es/Dom/shadow.mjs";
import d from "../../../rc-util/es/hooks/useEvent.mjs";
import on from "../../../rc-util/es/hooks/useId.mjs";
import h from "../../../rc-util/es/hooks/useLayoutEffect.mjs";
import nn from "../../../rc-util/es/isMobile.mjs";
import * as t from "react";
import xe from "./context.mjs";
import tn from "./hooks/useAction.mjs";
import rn from "./hooks/useAlign.mjs";
import un from "./hooks/useWatch.mjs";
import an from "./hooks/useWinClick.mjs";
import ln from "./Popup/index.mjs";
import sn from "./TriggerWrapper.mjs";
import { getAlignPopupClassName as pn, getMotion as Ee } from "./util.mjs";
var cn = ["prefixCls", "children", "action", "showAction", "hideAction", "popupVisible", "defaultPopupVisible", "onPopupVisibleChange", "afterPopupVisibleChange", "mouseEnterDelay", "mouseLeaveDelay", "focusDelay", "blurDelay", "mask", "maskClosable", "getPopupContainer", "forceRender", "autoDestroy", "destroyPopupOnHide", "popup", "popupClassName", "popupStyle", "popupPlacement", "builtinPlacements", "popupAlign", "zIndex", "stretch", "getPopupClassNameFromAlign", "alignPoint", "onPopupClick", "onPopupAlign", "arrow", "popupMotion", "maskMotion", "popupTransitionName", "popupAnimation", "maskTransitionName", "maskAnimation", "className", "getTriggerDOMNode"];
function mn() {
  var Ve = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Te, q = /* @__PURE__ */ t.forwardRef(function(o, Oe) {
    var J = o.prefixCls, P = J === void 0 ? "rc-trigger-popup" : J, Re = o.children, W = o.action, Fe = W === void 0 ? "hover" : W, Le = o.showAction, ze = o.hideAction, k = o.popupVisible, He = o.defaultPopupVisible, X = o.onPopupVisibleChange, _ = o.afterPopupVisibleChange, B = o.mouseEnterDelay, G = o.mouseLeaveDelay, K = G === void 0 ? 0.1 : G, Ie = o.focusDelay, Ue = o.blurDelay, Q = o.mask, Z = o.maskClosable, Ye = Z === void 0 ? !0 : Z, je = o.getPopupContainer, qe = o.forceRender, Je = o.autoDestroy, We = o.destroyPopupOnHide, Xe = o.popup, _e = o.popupClassName, Be = o.popupStyle, E = o.popupPlacement, $ = o.builtinPlacements, y = $ === void 0 ? {} : $, ee = o.popupAlign, Ge = o.zIndex, oe = o.stretch, T = o.getPopupClassNameFromAlign, A = o.alignPoint, Ke = o.onPopupClick, Qe = o.onPopupAlign, V = o.arrow, Ze = o.popupMotion, $e = o.maskMotion, eo = o.popupTransitionName, oo = o.popupAnimation, no = o.maskTransitionName, to = o.maskAnimation, ne = o.className, ro = o.getTriggerDOMNode, O = $o(o, cn), uo = Je || We || !1, ao = t.useState(!1), te = l(ao, 2), io = te[0], lo = te[1];
    h(function() {
      lo(nn());
    }, []);
    var re = t.useRef({}), C = t.useContext(xe), so = t.useMemo(function() {
      return {
        registerSubPopup: function(e, n) {
          re.current[e] = n, C == null || C.registerSubPopup(e, n);
        }
      };
    }, [C]), po = on(), co = t.useState(null), ue = l(co, 2), c = ue[0], mo = ue[1], fo = d(function(e) {
      Se(e) && c !== e && mo(e), C == null || C.registerSubPopup(po, e);
    }), go = t.useState(null), ae = l(go, 2), f = ae[0], vo = ae[1], ho = d(function(e) {
      Se(e) && f !== e && vo(e);
    }), R = t.Children.only(Re), s = (R == null ? void 0 : R.props) || {}, g = {}, Po = d(function(e) {
      var n, u, a = f;
      return (a == null ? void 0 : a.contains(e)) || ((n = we(a)) === null || n === void 0 ? void 0 : n.host) === e || e === a || (c == null ? void 0 : c.contains(e)) || ((u = we(c)) === null || u === void 0 ? void 0 : u.host) === e || e === c || Object.values(re.current).some(function(r) {
        return (r == null ? void 0 : r.contains(e)) || e === r;
      });
    }), yo = Ee(P, Ze, oo, eo), Co = Ee(P, $e, to, no), Mo = t.useState(He || !1), ie = l(Mo, 2), ko = ie[0], le = ie[1], i = k ?? ko, Ao = d(function(e) {
      k === void 0 && le(e);
    });
    h(function() {
      le(k || !1);
    }, [k]);
    var F = t.useRef(i);
    F.current = i;
    var se = d(function(e) {
      i !== e && (Ao(e), X == null || X(e));
    }), pe = t.useRef(), ce = function() {
      clearTimeout(pe.current);
    }, m = function(e) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
      ce(), n === 0 ? se(e) : pe.current = setTimeout(function() {
        se(e);
      }, n * 1e3);
    };
    t.useEffect(function() {
      return ce;
    }, []);
    var bo = t.useState(!1), me = l(bo, 2), fe = me[0], ge = me[1];
    h(function(e) {
      (!e || i) && ge(!0);
    }, [i]);
    var No = t.useState(null), ve = l(No, 2), L = ve[0], de = ve[1], Do = t.useState([0, 0]), he = l(Do, 2), Pe = he[0], So = he[1], z = function(e) {
      So([e.clientX, e.clientY]);
    }, wo = rn(i, c, A ? Pe : f, E, y, ee, Qe), p = l(wo, 9), xo = p[0], Eo = p[1], To = p[2], Vo = p[3], Oo = p[4], Ro = p[5], Fo = p[6], b = p[7], H = p[8], v = d(function() {
      fe || H();
    });
    un(i, f, c, v), h(function() {
      v();
    }, [Pe, E]), h(function() {
      i && !(y != null && y[E]) && v();
    }, [JSON.stringify(ee)]);
    var Lo = t.useMemo(function() {
      var e = pn(y, P, b, A);
      return j(e, T == null ? void 0 : T(b));
    }, [b, T, y, P, A]);
    t.useImperativeHandle(Oe, function() {
      return {
        forceAlign: v
      };
    });
    var zo = function(e) {
      ge(!1), H(), _ == null || _(e);
    }, Ho = function() {
      return new Promise(function(e) {
        de(function() {
          return e;
        });
      });
    };
    h(function() {
      L && (H(), L(), de(null));
    }, [L]);
    var Io = t.useState(0), ye = l(Io, 2), Uo = ye[0], Yo = ye[1], jo = t.useState(0), Ce = l(jo, 2), qo = Ce[0], Jo = Ce[1], Wo = function(e, n) {
      if (v(), oe) {
        var u = n.getBoundingClientRect();
        Yo(u.width), Jo(u.height);
      }
    }, Xo = tn(io, Fe, Le, ze), Me = l(Xo, 2), N = Me[0], D = Me[1], S = function(e, n, u, a) {
      g[e] = function(r) {
        var w;
        a == null || a(r), m(n, u);
        for (var Y = arguments.length, De = new Array(Y > 1 ? Y - 1 : 0), x = 1; x < Y; x++)
          De[x - 1] = arguments[x];
        (w = s[e]) === null || w === void 0 || w.call.apply(w, [s, r].concat(De));
      };
    }, ke = N.has("click"), I = D.has("click") || D.has("contextMenu");
    (ke || I) && (g.onClick = function(e) {
      var n;
      F.current && I ? m(!1) : !F.current && ke && (z(e), m(!0));
      for (var u = arguments.length, a = new Array(u > 1 ? u - 1 : 0), r = 1; r < u; r++)
        a[r - 1] = arguments[r];
      (n = s.onClick) === null || n === void 0 || n.call.apply(n, [s, e].concat(a));
    }), an(i, I, f, c, Q, Ye, Po, m);
    var _o = N.has("hover"), Bo = D.has("hover"), Ae, be;
    _o && (S("onMouseEnter", !0, B, function(e) {
      z(e);
    }), Ae = function() {
      m(!0, B);
    }, A && (g.onMouseMove = function(e) {
      var n;
      (n = s.onMouseMove) === null || n === void 0 || n.call(s, e);
    })), Bo && (S("onMouseLeave", !1, K), be = function() {
      m(!1, K);
    }), N.has("focus") && S("onFocus", !0, Ie), D.has("focus") && S("onBlur", !1, Ue), N.has("contextMenu") && (g.onContextMenu = function(e) {
      var n;
      z(e), m(!0), e.preventDefault();
      for (var u = arguments.length, a = new Array(u > 1 ? u - 1 : 0), r = 1; r < u; r++)
        a[r - 1] = arguments[r];
      (n = s.onContextMenu) === null || n === void 0 || n.call.apply(n, [s, e].concat(a));
    }), ne && (g.className = j(s.className, ne));
    var U = M(M({}, s), g), Ne = {}, Go = ["onContextMenu", "onClick", "onMouseDown", "onTouchStart", "onMouseEnter", "onMouseLeave", "onFocus", "onBlur"];
    Go.forEach(function(e) {
      O[e] && (Ne[e] = function() {
        for (var n, u = arguments.length, a = new Array(u), r = 0; r < u; r++)
          a[r] = arguments[r];
        (n = U[e]) === null || n === void 0 || n.call.apply(n, [U].concat(a)), O[e].apply(O, a);
      });
    });
    var Ko = /* @__PURE__ */ t.cloneElement(R, M(M({}, U), Ne)), Qo = {
      x: Vo,
      y: Oo
    }, Zo = V ? M({}, V !== !0 ? V : {}) : null;
    return /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement(en, {
      disabled: !i,
      ref: ho,
      onResize: Wo
    }, /* @__PURE__ */ t.createElement(sn, {
      getTriggerDOMNode: ro
    }, Ko)), /* @__PURE__ */ t.createElement(xe.Provider, {
      value: so
    }, /* @__PURE__ */ t.createElement(ln, {
      portal: Ve,
      ref: fo,
      prefixCls: P,
      popup: Xe,
      className: j(_e, Lo),
      style: Be,
      target: f,
      onMouseEnter: Ae,
      onMouseLeave: be,
      zIndex: Ge,
      open: i,
      keepDom: fe,
      onClick: Ke,
      mask: Q,
      motion: yo,
      maskMotion: Co,
      onVisibleChanged: zo,
      onPrepare: Ho,
      forceRender: qe,
      autoDestroy: uo,
      getPopupContainer: je,
      align: b,
      arrow: Zo,
      arrowPos: Qo,
      ready: xo,
      offsetX: Eo,
      offsetY: To,
      onAlign: v,
      stretch: oe,
      targetWidth: Uo / Ro,
      targetHeight: qo / Fo
    })));
  });
  return process.env.NODE_ENV !== "production" && (q.displayName = "Trigger"), q;
}
const On = mn(Te);
export {
  On as default,
  mn as generateTrigger
};
//# sourceMappingURL=index.mjs.map
